import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { Subscription } from 'rxjs';
import * as Redux from 'redux';
import { NgxSpinnerService } from 'ngx-spinner';
import * as TabsActions from '@iv/store/tabs/tabs.actions';
import * as ColumnsActions from '@iv/store/columns/columns.actions';
import { getColumnsEntities } from '@iv/store/columns/columns.selectors';
import { getCurrentTab } from '@iv/store/tabs/tabs.selectors';
import { Future } from '@iv/model/instrument';
import {
  FuturesMonitorService
} from '../../services/futures-monitor.service';
import { CommonService } from 'app/core/services/common.service';
import { DxAutocompleteComponent } from 'devextreme-angular/ui/autocomplete';
import { DxSelectBoxComponent } from 'devextreme-angular/ui/select-box';
import { GridComponent } from '@iv/shared/components/grid/grid.component';
import { AppState } from '@iv/store/app.reducer';
import { AppStore } from '@iv/store/app.store';
import {
  getDefaultGroups,
  getGroups
} from '../../redux/futures-monitor.reducer';
import * as FuturesActions from '../../redux/futures-monitor.actions';
import { getAllFutures } from '@iv/store/futures/futures.reducer';
import Utils from '@iv/shared/utils';
import { FuturesCalculatorComponent } from 'app/calculators/futures-calculator/futures-calculator.component';
import { GroupDropdownComponent } from '../group-dropdown/group-dropdown.component';
import { ColumnsChooserComponent } from '@iv/shared/components/grid/columns-chooser/columns-chooser.component';
import { ThemeColor } from 'app/common/enums/theme-color.enum';
import { getPermissions } from '@iv/store/permissions/permissions.reducer';
import { PermissionTypes } from '@iv/store/permissions/permissions.models';
import { Group } from '@iv/model/group';
import { ProbabilityCalculatorComponent } from 'app/calculators/probability-calculator/probability-calculator.component';

import * as moment from 'moment';
import {PaymentWindowService} from '../../../payment-window.service';

@Component({
  selector: 'iv-live-my-futures-monitor',
  templateUrl: './futures-monitor.component.html',
  styleUrls: ['./futures-monitor.component.scss']
})
export class FuturesMonitorComponent implements OnInit, OnDestroy {

  private static MAX_GROUP_INSTRUMENTS = 200;
  private static TIME_CONTAINER = 'globalTime';
  public themeColor: ThemeColor;
  public themeColorEnum = ThemeColor;
  public calculatorType: 'options' | 'probability' = 'options';
  weekday = ['Sun', 'Mon', 'Tue', 'Wed', 'Th', 'Fri', 'Sat'];
  month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
  gridVisibleColumns: any[];
  advancedSearchVisible = false;
  editColumnsPopupPosition: any = {my: 'left top', at: 'bottom', of: '#editColumnsButton'};
  mode: PermissionTypes = getPermissions(this.store.getState()).find(permission => {
    return permission === PermissionTypes.RT_FUTURES || permission === PermissionTypes.EOD_FUTURES;
  });
  isDelayed = this.mode === PermissionTypes.EOD_FUTURES;
  isRt = this.mode === PermissionTypes.RT_FUTURES;
  currentGroupStocks: any[] = null;
  selectedStocks: any[] = [];
  stockName = '';
  groups: Group[] = [];
  defaultGroups: Group[] = [];
  defaultColumns: any[] = [];
  visibleColumns: string[];
  settingColumns: any[] = [];
  gridColumns: any[];
  isLoading = false;
  createPopupVisible = false;
  deleteGroupPopupVisible = false;
  editColumnsPopupVisible = false;
  isMac = !!navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i);
  isMobile = Utils.isMobile();
  editColumnsClass = (this.isMac ? 'edit-columns-popup mac' : 'edit-columns-popup') + (this.isMobile ? ' mobile' : '');
  unsubscribeStore;
  chartsPopupVisible = false;
  selectedFuture: any = {};
  calculatorPopupVisible = false;
  isEODOptions = false;
  isEODProbability = false;
  regionIdOptions;
  regionIdProbability;
  popupCredit = false;
  @ViewChild(GroupDropdownComponent, {static: false}) groupDropdown !: GroupDropdownComponent;
  @ViewChild(ColumnsChooserComponent, {static: false}) columnsChooser !: ColumnsChooserComponent;
  @ViewChild(GridComponent, {static: false}) dataGrid !: GridComponent;
  @ViewChild(DxSelectBoxComponent, {static: false}) selectBox !: DxSelectBoxComponent;
  @ViewChild(DxAutocompleteComponent, {static: false}) autocomplete !: DxAutocompleteComponent;
  @ViewChild(FuturesCalculatorComponent, {static: false}) futuresCalculator !: FuturesCalculatorComponent;
  @ViewChild(ProbabilityCalculatorComponent, {static: false}) probabilityCalculator !: ProbabilityCalculatorComponent;
  @Output() symbolClickEvent = new EventEmitter<any>();
  @Output() openDropdownEvent = new EventEmitter<any>();
  private selectedGroupId: any;
  private instrumentsInterval;
  private groupDataSubscription: Subscription;
  private _alwaysVisibleColumns = ['checkbox', 'symbol'];
  private sorting = {};
  private NYDateTime;
  emptyMessage = 'Data not found';
  private isLoadFirst = true;
  public isError = false;
  protected readonly JSON: JSON = JSON;
  protected readonly sessionStorage: Storage = sessionStorage;

  constructor(
    private _futuresMonitorService: FuturesMonitorService,
    private commonService: CommonService,
    private spinner: NgxSpinnerService,
    @Inject(AppStore) private store: Redux.Store<AppState>,

    private readonly paymentWindowService: PaymentWindowService

  ) {
    this.unsubscribeStore = store.subscribe(() => this.updateState());
    this.updateState();
  }

  private _futures: Future[] = [];

  get futures(): Future[] {
    return this._futures;
  }

  @Input() set futures(value: Future[]) {
    this._futures = value;
  }

  private _selectedGroup: any = {};

  get selectedGroup(): any {
    return this._selectedGroup;
  }

  private _host = 'https://www.ivolatility.com';

  public get host() {
    return this._host;
  }

  set selectedGroup(value: any) {
    const oldId = this.selectedGroup.id;
    const checkbox = document.querySelector('.checkbox_cell_header input') as HTMLInputElement;
    if (value && (oldId !== value.id) && this.visibleColumns) {
      this._selectedGroup = value;
      this.store.dispatch(TabsActions.updateTabData({
        name: 'description',
        value: value.name
      }));
      this.getGroupData(true, true, () => {
        this.gridVisibleColumns = this.getGridVisibleColumns();
        if (checkbox && checkbox.checked) checkbox.checked = false;
      });
    }
  }

  openDropdown(i: number) {
    if (i === 0) {
      this.groupDropdown.showDropdown = false;
    }
    this.openDropdownEvent.emit();
  }

  applyScreeners() {
    const checkbox = document.querySelector('.checkbox_cell_header input') as HTMLInputElement;
    this.getGroupData(true, true, () => {
      this.gridVisibleColumns = this.getGridVisibleColumns();
      if (checkbox && checkbox.checked) checkbox.checked = false;
    });
    this.emptyMessage = 'Data not found';
  }

  updateState() {
    const state = this.store.getState();
    const columnsConfig = getColumnsEntities(state)['FuturesMonitor'];
    const currentTab = getCurrentTab(state);
    const data = currentTab.data;
    if (data) {
      this.selectedGroupId = data.selectedGroupId;
      this.visibleColumns = data.visibleColumns?.map((column: string) => column.toLowerCase());
      this.sorting = data.sorting;
    }
    this.defaultColumns = columnsConfig;
    this.groups = getGroups(state);
    this.defaultGroups = getDefaultGroups(state);
    this.selectedGroup = [...this.groups, ...this.defaultGroups].find(group => group.id === this.selectedGroupId);
    this.futures = getAllFutures(state);
  }

  ngOnInit(): void {
    this.paymentWindowService.showPaymentWindow();
    this._futuresMonitorService.getGlobalDate().subscribe(globalData => {
      let myMoment: moment.Moment = moment(globalData.today);
      this.NYDateTime = myMoment.toDate();
      this._futuresMonitorService.getColumns()
        .subscribe(data => {
          if (!this.defaultColumns) {
            this._updateDefaultConfig(data.visibleColumns.map(x => x));
          }
          if (!this.visibleColumns || (data.visibleColumns.toString() !== this.visibleColumns.toString())) {
            this._updateTabData('visibleColumns', this.defaultColumns);
          }
          if (!this.sorting) {
            this._updateTabData('sorting', this._getSorting());
          }
          this.settingColumns = Object.values(data.settingColumns).map(x => Object.assign({}, x));
          this.gridColumns = Object.assign({}, data.gridColumns);
          this.sortData();
          this.gridVisibleColumns = this.getGridVisibleColumns();
          this.store.dispatch(FuturesActions.selectGroup(12));
          this.instrumentsInterval = setInterval(() => {
            this.getGroupData(false, false);
          }, 20 * 1000);
          this._updateHeaderTime();
        });
    });
  }

  isMarketClose() {
    return !(!this.isWeekend()
      && (this.NYDateTime.getTime() - this.getStartMarkterDate().getTime() >= 0)
      && (this.NYDateTime.getTime() - this.getEndMarkterDate().getTime() <= 0)
    );
  }

  getEndMarkterDate() {
    return this.getDateWithHours(16, 15 + (this.isDelayed ? 20 : 0));
  }

  getDateWithHours(hour, minute) {
    const date = new Date();
    date.setHours(hour);
    date.setMinutes(minute);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  }

  isWeekend() {
    const day = new Date().getDay();
    return day === 0 || day === 6;
  }

  getStartMarkterDate() {
    return this.getDateWithHours(9, 30 + (this.isDelayed ? 20 : 0));
  }

  ngOnDestroy(): void {
    if (this.instrumentsInterval) {
      clearInterval(this.instrumentsInterval);
    }
    if (typeof this.unsubscribeStore === 'function') {
      this.unsubscribeStore();
    }
  }

  openCreateGroupDialog() {
    this.createPopupVisible = true;
  }

  public openDeleteGroupDialog(): void {
    this.deleteGroupPopupVisible = true;
  }

  public onDeleteGroupAccept(): void {
    if (!this.defaultGroups.find(group => group.name === this.selectedGroup.name)) {
      this.onDeleteGroupApply({
        deletedGroupId: this.selectedGroup.id,
        newCurrentGroupId: this.defaultGroups[0].id
      });
      this.selectedGroup = this.defaultGroups[0];
    }
    this.deleteGroupPopupVisible = false;
  }

  onEditColumnsClick() {
    if (this.isMobile) {
      this.editColumnsPopupPosition = {my: 'center', at: 'center', of: window};
    }
    this.editColumnsPopupVisible = true;
  }

  onAutocompleteItemClick(e?: any) {
    this.addFutures([e.itemData.underlyingId]);
    this.resetAutocomplete();
  }

  onAutocompleteKeyDown(e?: any) {
    if (e.event.keyCode === 13) {
      let futuresToAdd: any = this.stockName
        .replace(/(\w+)(\s+)/g, '$1,')
        .replace(/([,])(\s+)/g, '$1')
        .trim()
        .split(',');
      futuresToAdd = futuresToAdd.map(stockName => {
        if (stockName) {
          const symbol = stockName.split(':')[0];
          const exchange = stockName.split(':')[1];
          const symbolRegexp = new RegExp('^' + symbol + '$', 'i');
          const exchangeRegexp = (exchange !== undefined) ? new RegExp('^' + exchange + '$', 'i') : undefined;

          const future = this.futures.find(item => {
            return symbolRegexp.test(item.symbol)
              && (exchangeRegexp === undefined || exchangeRegexp.test(item.exchange));
          });

          if (future) {
            return future.underlyingId;
          }
        }
      }, this);
      this.addFutures(futuresToAdd.filter(item => item));
      this.resetAutocomplete();
    }
  }

  onRemoveSelectedClick() {
    if (!((this._selectedGroup && this._selectedGroup.isDefault) || !this.selectedStocks.length)) {
      this.removeSelectedStocks();
    }
  }

  onUploadDataClick() {
    this.popupCredit = true;
  }

  onColumnSwitch(columns: string[]) {
    this.editColumnsPopupVisible = false;
    this.store.dispatch(TabsActions.updateTabData({
      name: 'visibleColumns',
      value: columns
    }));
    this.getGroupData(true, true, () => {
      this.gridVisibleColumns = this.getGridVisibleColumns();
    });
  }

  onPopupCancel(popupVisible) {
    this[popupVisible] = false;
  }

  onGroupNameApply(event: { name: string, toggleLoading: () => void } ) {
    const { name, toggleLoading } = event;

    this.saveGroupName(name, toggleLoading);
  }

  saveGroupName(name: string, toggleLoading: () => void) {
    this.emptyMessage = 'Start searching to add data';
    this._futuresMonitorService.createGroup(name).subscribe(data => {
      let type = 'success';
      let text = ('Group was successfully created');
      if (data.RETURN_VALUE === 0 && data.GROUPS_ID > -1) {
        const newGroup = {id: data.GROUPS_ID, name};
        this.store.dispatch(FuturesActions.addGroup(newGroup));
        this.handleGroupClick(newGroup);
      } else {
        type = 'error';
        text = ('Group was not created. Try again later.');
      }
      toggleLoading();
      this.createPopupVisible = false;
      this.notify(text, type);
    });
  }

  calculatorMessage(event) {
    this.notify(event.message, event.type);
  }

  onRenameGroupApply(name: string) {
    const group = this.selectedGroup;
    if (name !== '') {
      this._futuresMonitorService.renameGroup(group.id, name).subscribe();
    }
  }

  onDeleteGroupApply(event: { deletedGroupId: number, newCurrentGroupId?: number }) {
    this._futuresMonitorService.deleteGroup(event.deletedGroupId)
      .subscribe(p => {
        if (p.RETURN_VALUE === 0) {
          this.store.dispatch(FuturesActions.deleteGroup(event.deletedGroupId, event.newCurrentGroupId));
          this.store.dispatch(FuturesActions.selectGroup(event.newCurrentGroupId));
          this.store.dispatch(TabsActions.updateTabData({
            name: 'selectedGroupId',
            value: event.newCurrentGroupId
          }));

          const type = 'success';
          const text = ('Group was successfully deleted');
          this.notify(text, type);
        }
      });
  }

  /***Grid events***/

  toggleAllRowsSelection(selection: boolean) {
    this.currentGroupStocks.forEach(future => future.selected = selection);
    this.currentGroupStocks = this.currentGroupStocks.splice(0);
    this.selectedStocks = this.getSelectedStocks();
  }

  onCheckboxClick(event) {
    const row = this.currentGroupStocks.find(future => future.underlyingid === event.underlyingid);
    row.selected = ((row.selected === undefined || row.selected === false) ? true : undefined);
    this.currentGroupStocks = this.currentGroupStocks.splice(0);
    this.selectedStocks = this.getSelectedStocks();
  }

  onSymbolClick(underlyingId: number) {
    this.symbolClickEvent.emit(underlyingId);
  }

  handleSorting(columnName: string) {
    this.changeSortType(columnName);
    this.sortData();
  }

  downloadFile(data: any) {
    const date = new Date();
    Utils.downloadFile(
      data,
      (this.selectedGroup.name + '_' + date.getFullYear() + '_' + (date.getMonth() + 1) + '_' + date.getDate()).split(' ').join('_')
    );
  }

  onSearchButtonClick() {
    this._showAdvancedSearchWindow();
  }

  onAddSymbols(ids: number[]) {
    this.addFutures(Array.isArray(ids) ? ids : [ids]);
    this.advancedSearchVisible = false;
  }

  handleGroupClick(group: any) {
    this.currentGroupStocks.forEach(future => {
      future.selected = false;
    });

    this.store.dispatch(FuturesActions.selectGroup(group.id));
    this.store.dispatch(TabsActions.updateTabData({
      name: 'selectedGroupId',
      value: group.id
    }));
  }

  getAllGroups() {
    return [...this.groups, ...this.defaultGroups];
  }

  getGridVisibleColumns() {
    const set = new Set([...this._alwaysVisibleColumns, ...this.visibleColumns]);
    return Array.from(set);
  }

  saveDefault(columns: string[]) {
    this._updateDefaultConfig(columns);
  }

  onRenameGroupClick() {
    document.getElementById('groupInput').focus();
  }

  onChartButtonClicked(future: string) {
    this.selectedFuture = future;
    this.chartsPopupVisible = true;
  }

  onCalculatorButtonClick(future?) {
    this.selectedFuture = future;
    this.calculatorPopupVisible = true;
  }

  closeCalculatorWindow() {
    this.onPopupCancel('calculatorPopupVisible');
    this.futuresCalculator.clearAll();
    this.probabilityCalculator.clearAll();
    this.selectedFuture = null;
    this.futuresCalculator.ngOnDestroy();
    this.probabilityCalculator.ngOnDestroy();
  }

  switchCalculatorMode(): void {
    this.switchModeOptions();
    this.switchModeProbability();
  }

  private switchModeOptions(): void {
    this.futuresCalculator.switchMode();
    this.isEODOptions = !this.isEODOptions;
  }

  private switchModeProbability(): void {
    this.probabilityCalculator.switchMode();
    this.isEODProbability = !this.isEODProbability;
  }

  returnRegionOptions(region: number): void {
    this.regionIdOptions = region;
    if (this.regionIdOptions === 2 || this.regionIdOptions === 3 || this.regionIdOptions === 4) {
      this.isEODOptions = true;
    }
  }

  returnRegionProbability(region: number): void {
    this.regionIdProbability = region;
    if (this.regionIdProbability === 2 || this.regionIdProbability === 3 || this.regionIdProbability === 4) {
      this.isEODProbability = true;
    }
  }

  /**GRID EVENTS**/

  closeFuturesDropdown() {
    this.futuresCalculator.closeFuturesDropdown();
  }

  closeProbabilityDropdown() {
    this.probabilityCalculator.closeProbabilityDropdown();
  }

  getStockType(item: any) {
    return Utils.getStockType(item);
  }

  private _getDayOfWeek(index) {
    return this.weekday[index];
  }

  private _getMonth(index) {
    return this.month[index];
  }

  private _updateHeaderTime() {
    try {
      const isClose = this.isMarketClose();
      const timeContent = `${this._getDayOfWeek(this.NYDateTime.getDay())}, ${this._getMonth(this.NYDateTime.getMonth())} ${this.NYDateTime.getDate()}, ${this.NYDateTime.getFullYear()}
      <br/>${(isClose ? 'end-of-day' : (this.isRt ? 'real-time mode' : '20-min delayed mode'))}`;
      window.parent.postMessage({message: 'timeHeaderContent', value: timeContent}, '*');
    } catch (e) {
    }
  }

  private getGroupData(stopPrevious, hasMask, callback?) {
    if (this.selectedGroup) {
      if (hasMask) {
        this.hideSpinner();
        this.isLoading = true;
        this.spinner.show('futuresMonitorSpinner');
      }
      if (stopPrevious && (this.groupDataSubscription && !this.groupDataSubscription.closed)) {
        this.hideSpinner();
        this.groupDataSubscription.unsubscribe();
        this._loadData(callback);
      } else if (this.groupDataSubscription === undefined || this.groupDataSubscription.closed) {
        this._loadData(callback);
      }
    }
  }

  private hideSpinner(): void {
    if (this.isLoading) {
      this.isLoading = false;
      this.spinner.hide('futuresMonitorSpinner');
    }
  }

  private _loadData(callback?) {
    this.groupDataSubscription = this._futuresMonitorService.getGroupData(
      this.mode.toLowerCase(),
      this.selectedGroup.id,
      this._getColumnsToLoad(false),
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      this.isLoadFirst
    ).subscribe(
      response => {
        const data = response.body;
        if (response.status === 200) {
          if (this.isLoading) {
            this.spinner.hide('futuresMonitorSpinner');
            this.isLoading = false;
          }
          if (this.currentGroupStocks) {
            // set selected value
            data.forEach(future => {
              const item = this.currentGroupStocks.filter(i => {
                return i.underlyingid === future.underlyingid;
              })[0];
              if (item) {
                future.selected = item.selected === undefined ? false : item.selected;
              }
            });
            this.currentGroupStocks = data.filter(future => future.underlyingid);
          } else {
            this.currentGroupStocks = data.filter(future => future.underlyingid);
          }
          if (callback) {
            callback(this);
          }
        }
      },
      (err) => {
        if (this.isLoading) {
          this.spinner.hide('futuresMonitorSpinner');
          this.isLoading = false;
        }
      }
    );
    this.isLoadFirst = false;
  }

  private isGroupExist(name) {
    return this.groups.some(group => group.name === name);
  }

  private notify(text, type) {
    this.commonService.sendNotification(text, type);
  }

  private removeSelectedStocks() {
    const futuresToDelete = [];
    const selectedStocks = this.getSelectedStocks();
    selectedStocks.forEach(function (future) {
      if (future != null) {
        futuresToDelete.push(future.underlyingid);
      }
    }, this);
    this._futuresMonitorService.deleteInstrument(this.selectedGroup.id, futuresToDelete)
      .subscribe(data => {
        if (data.RETURN_VALUE === 0) {
          this.getGroupData(true, true);
          this.selectedStocks = [];
        }
      });
  }

  private getSelectedStocks(): any {
    return this.currentGroupStocks.filter(future => {
      return future.selected === true;
    });
  }

  private addFutures(futuresIds: number[]) {
    const group = this.selectedGroup;
    if (group.isDefault) {
      // create group then add futures
      let newName = group.name + '.1';
      if (this.isGroupExist(newName)) {
        newName += '.1';
      }
      this._futuresMonitorService.createGroup(newName)
        .subscribe(data => {
          if (data.RETURN_VALUE === 0 && data.GROUPS_ID > -1) {
            const ids = this.currentGroupStocks.map(future => future.underlyingid);
            this._futuresMonitorService.addInstruments(data.GROUPS_ID, [...ids, ...futuresIds])
              .subscribe(p => {
                if (p.RETURN_VALUE) {
                  const newGroup = {id: data.GROUPS_ID, name: newName};
                  this.store.dispatch(FuturesActions.addGroup(newGroup));
                  this.handleGroupClick(newGroup);
                }
              });
          }
        });
    } else if (this.currentGroupStocks.length >= FuturesMonitorComponent.MAX_GROUP_INSTRUMENTS) {
      this.notify(`Up to ${FuturesMonitorComponent.MAX_GROUP_INSTRUMENTS} tickers is allowed.
      Please delete one or more tickers to add a new one.`, 'error');
    } else {
      this._futuresMonitorService.addInstruments(this.selectedGroup.id, futuresIds).subscribe(p => {
        if (p.RETURN_VALUE === 0) {
          this.getGroupData(true, true);
        }
      });
    }
  }

  private resetAutocomplete() {
    if (this.autocomplete) {
      this.autocomplete.instance.reset();
    }
  }

  uploadData() {
    this.isError = false;
    this.popupCredit = false;
    if (this.currentGroupStocks.length > 0) {
      const selectedStocks = this.getSelectedStocks();
      const ids = (selectedStocks.length > 0) ? selectedStocks : [];
      this._futuresMonitorService.uploadDataBlob(
        this.selectedGroup.id,
        this.mode.toLowerCase(),
        ids.map((item) => item ? item.underlyingid : null),
        this._getColumnsToLoad(true),
        this.selectedGroup.name,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined
      )
        .subscribe(data => {
          this.downloadFile(data);
        }, error => {
          this.isError = true;
          this.popupCredit = true;
        });
    }
  }

  private _getVisibleColumns() {
    return this.visibleColumns.filter(item => item !== 'checkbox');
  }

  private sortData() {
    const columns = Object.assign({}, this.gridColumns);
    const sorting = this.sorting;
    if (Object.entries(sorting).length === 0) {
      for (const column in columns) {
        if (columns[column].sortDirection) {
          delete columns[column].sortDirection;
        }
      }
    } else {
      for (const column in columns) {
        if (sorting[column]) {
          columns[column].sortDirection = sorting[column];
        } else {
          delete columns[column].sortDirection;
        }
      }
    }
    this.gridColumns = columns;
  }

  private _showAdvancedSearchWindow() {
    this.advancedSearchVisible = true;
  }

  private _updateDefaultConfig(columns: string[]) {
    this.store.dispatch(ColumnsActions.updateColumnsConfig({
      name: 'FuturesMonitor',
      value: columns
    }));
  }

  private _updateTabData(name, value) {
    this.store.dispatch(TabsActions.updateTabData({
      name: name,
      value: value
    }));
  }

  private _getSorting() {
    return {
      'symbol': 'asc'
    };
  }

  private changeSortType(dataField: string) {
    const sortTypes = {
      'asc': 'desc',
      'desc': '',
      '': 'asc'
    };

    const newSortType = sortTypes[this.sorting[dataField]] ?? 'asc';

    if (newSortType === '') {
      this.currentGroupStocks = this.currentGroupStocks.splice(0);
    }

    const sort = { [dataField]: newSortType };

    this.store.dispatch(TabsActions.updateTabData({
      name: 'sorting',
      value: sort
    }));
  }

  private _getColumnsToLoad(removeGroup?: boolean) {
    const columns = [];
    if (this.visibleColumns.indexOf('quotetime') > -1) {
      columns.push(...['atclose_eod', 'updatedate']);
    }
    if (this.visibleColumns.indexOf('ivx30highlow') > -1) {
      columns.push(...['ivxhigh30_eod', 'ivxlow30_eod']);
    }
    if (this.visibleColumns.indexOf('ivx60highlow') > -1) {
      columns.push(...['ivxhigh60_eod', 'ivxlow60_eod']);
    }
    if (this.visibleColumns.indexOf('ivx90highlow') > -1) {
      columns.push(...['ivxhigh90_eod', 'ivxlow90_eod']);
    }
    if (this.visibleColumns.indexOf('ivx120highlow') > -1) {
      columns.push(...['ivxhigh120_eod', 'ivxlow120_eod']);
    }
    if (this.visibleColumns.indexOf('ivx150highlow') > -1) {
      columns.push(...['ivxhigh150_eod', 'ivxlow150_eod']);
    }
    if (this.visibleColumns.indexOf('ivx180highlow') > -1) {
      columns.push(...['ivxhigh180_eod', 'ivxlow180_eod']);
    }
    if (this.visibleColumns.indexOf('ivx30highlowdate') > -1) {
      columns.push(...['ivxhighdate30_eod', 'ivxlowdate30_eod']);
    }
    if (this.visibleColumns.indexOf('ivx60highlowdate') > -1) {
      columns.push(...['ivxhighdate60_eod', 'ivxlowdate60_eod']);
    }
    if (this.visibleColumns.indexOf('ivx90highlowdate') > -1) {
      columns.push(...['ivxhighdate90_eod', 'ivxlowdate90_eod']);
    }
    if (this.visibleColumns.indexOf('ivx120highlowdate') > -1) {
      columns.push(...['ivxhighdate120_eod', 'ivxlowdate120_eod']);
    }
    if (this.visibleColumns.indexOf('ivx150highlowdate') > -1) {
      columns.push(...['ivxhighdate150_eod', 'ivxlowdate150_eod']);
    }
    if (this.visibleColumns.indexOf('ivx180highlowdate') > -1) {
      columns.push(...['ivxhighdate180_eod', 'ivxlowdate180_eod']);
    }
    const set = new Set([...this.visibleColumns, ...columns]);
    let array = Array.from(set);
    if (removeGroup) {
      array = array.filter(value => {
        return value !== 'ivx30highlow' &&
          value !== 'ivx60highlow' &&
          value !== 'ivx30highlowdate' &&
          value !== 'ivx60highlowdate' &&
          value !== 'ivx90highlowdate' &&
          value !== 'ivx120highlowdate' &&
          value !== 'ivx150highlowdate' &&
          value !== 'ivx180highlowdate' &&
          value !== 'regionid' &&
          value !== 'ivx90highlow' &&
          value !== 'ivx120highlow' &&
          value !== 'ivx150highlow' &&
          value !== 'ivx180highlow' &&
          value !== 'quotetime';
      });
    }
    return array;
  }

  public switchCalculatorType(type: 'options' | 'probability'): void {
    this.calculatorType = type;
  }
}

